import { getEmoji } from './emoji'

const NEWLINE_REGEX = /(\r\n|\r|\n)/

/**
 * Checks if the given text represents a newline character.
 *
 * @param {string} text - The text to check.
 * @returns {boolean} True if the text is a newline character ('\r\n', '\r', or '\n'),
 * otherwise false.
 */
const isNewline = text => text === '\r\n' || text === '\r' || text === '\n'

/**
 * Processes the input text and returns an array of objects representing special characters,
 * such as emojis and newlines, found in the text.
 *
 * Each object in the returned array contains:
 * - `text`: The cleaned text segment or newline character.
 * - `isEmoji`: Boolean indicating if the segment is an emoji.
 * - `isNewline`: Boolean indicating if the segment is a newline.
 *
 * @param {string} text - The input text to process for special characters.
 * @returns {Array<{text: string, isEmoji: boolean, isNewline: boolean}>} Array of objects
 * representing special characters.
 */
export const getSpecialCharacters = message =>
  getEmoji(message).flatMap(({ text }) =>
    text.split(NEWLINE_REGEX).flatMap(part => {
      if (isNewline(part)) return [ { text: part, isEmoji: false, isNewline: true } ]

      const cleaned = part.trim().replace(/[ \t]+/g, ' ')
      if (!cleaned) return []

      const isEmoji = /\p{Extended_Pictographic}/u.test(cleaned)
      return [ { text: cleaned, isEmoji, isNewline: false } ]
    })
  )
